const Usertypes = {
  Admin: 100,
  User: 1,
};

export default Usertypes;
